/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: WgkFi0SpEFe_
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import InputFieldUnderline from "../../InputFieldUnderline"; // plasmic-import: BftYWjxj5zbk/component
import Textarea from "../../Textarea"; // plasmic-import: mONk3pvEmt2Y/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebSupportContainer.module.css"; // plasmic-import: WgkFi0SpEFe_/css

createPlasmicElementProxy;

export const PlasmicWebSupportContainer__VariantProps = new Array("status");

export const PlasmicWebSupportContainer__ArgProps = new Array(
  "theFormGoesHere",
  "textareaWrapp4"
);

const $$ = {};

function PlasmicWebSupportContainer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootstatus_success]: hasVariant($state, "status", "success") }
      )}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.text, {
          [sty.textstatus__default]: hasVariant($state, "status", "_default"),
          [sty.textstatus_success]: hasVariant($state, "status", "success")
        })}
      >
        {hasVariant($state, "status", "success")
          ? "."
          : hasVariant($state, "status", "_default")
            ? "how can we help?"
            : "..."}
      </div>
      {(hasVariant($state, "status", "success") ? false : true)
        ? renderPlasmicSlot({
            defaultContents: (
              <div className={classNames(projectcss.all, sty.freeBox__bsR3)}>
                <div className={classNames(projectcss.all, sty.freeBox__rxZqy)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ltZff)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__m9Fbn
                      )}
                    >
                      {"I'm"}
                    </div>
                  </div>
                  <InputFieldUnderline
                    className={classNames(
                      "__wab_instance",
                      sty.inputFieldUnderline__gHZb
                    )}
                    id={"iAmId"}
                    inputName={"inquirerName"}
                    onClick={async () => {
                      const $steps = {};
                    }}
                    onSurface={"onGrey"}
                    padding={"noPadding"}
                    placeholder={'"John Smith"'}
                    required={true}
                    type={"text"}
                    value={``}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__nZeDa)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___3ManI)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__dcHql)}
                    >
                      <Textarea
                        className={classNames(
                          "__wab_instance",
                          sty.textarea___4QTvd
                        )}
                        flexibleLayout={"bigHeight"}
                        id={"messageTextArea"}
                        inputName={"inquirerMessage"}
                        placeholder={"message..."}
                        radius={"halfModule"}
                        required={true}
                      />
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__b8LPw)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__hHhhr)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__hNJq)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__wdIp
                        )}
                      >
                        {"and I\u2019d like to continue this conversation at\r"}
                      </div>
                    </div>
                    <InputFieldUnderline
                      className={classNames(
                        "__wab_instance",
                        sty.inputFieldUnderline__q2Czf
                      )}
                      id={"emailInput"}
                      inputName={"inquirerEmail"}
                      onSurface={"onGrey"}
                      padding={"noPadding"}
                      placeholder={'"my.email@example.com"'}
                      required={true}
                      type={"email"}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__nekVu)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__iJli9
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{"[ "}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              projectcss.a__fRuRb,
                              projectcss.__wab_text,
                              projectcss.plasmic_default__inline,
                              sty.link___8GbS
                            )}
                            name={"webInqSendButton"}
                            platform={"react"}
                          >
                            {"send"}
                          </PlasmicLink__>
                        }
                        <React.Fragment>{" ]"}</React.Fragment>
                      </React.Fragment>
                    </div>
                  </div>
                </div>
              </div>
            ),

            value: args.theFormGoesHere
          })
        : null}
      <div
        data-plasmic-name={"dummySupportFormWrapper"}
        data-plasmic-override={overrides.dummySupportFormWrapper}
        className={classNames(projectcss.all, sty.dummySupportFormWrapper, {
          [sty.dummySupportFormWrapperstatus__default]: hasVariant(
            $state,
            "status",
            "_default"
          )
        })}
      >
        <div
          data-plasmic-name={"floatyWrapper7"}
          data-plasmic-override={overrides.floatyWrapper7}
          className={classNames(projectcss.all, sty.floatyWrapper7, {
            [sty.floatyWrapper7status_success]: hasVariant(
              $state,
              "status",
              "success"
            )
          })}
        />

        <div
          className={classNames(projectcss.all, sty.freeBox__rmSkn, {
            [sty.freeBoxstatus_success__rmSkngfFl1]: hasVariant(
              $state,
              "status",
              "success"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__c8Kn, {
              [sty.freeBoxstatus_success__c8KnGfFl1]: hasVariant(
                $state,
                "status",
                "success"
              )
            })}
          >
            <div
              data-plasmic-name={"textareaWrapp3"}
              data-plasmic-override={overrides.textareaWrapp3}
              className={classNames(projectcss.all, sty.textareaWrapp3, {
                [sty.textareaWrapp3status_success]: hasVariant(
                  $state,
                  "status",
                  "success"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <Textarea
                    className={classNames(
                      "__wab_instance",
                      sty.textarea__qbCfe
                    )}
                    flexibleLayout={"bigHeight"}
                    id={"messageTextArea"}
                    inputName={"inquirerMessage"}
                    placeholder={"placeholder"}
                    radius={"halfModule"}
                    required={true}
                  />
                ),

                value: args.textareaWrapp4
              })}
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"floatyWrapper8"}
          data-plasmic-override={overrides.floatyWrapper8}
          className={classNames(projectcss.all, sty.floatyWrapper8, {
            [sty.floatyWrapper8status_success]: hasVariant(
              $state,
              "status",
              "success"
            )
          })}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "text",
    "dummySupportFormWrapper",
    "floatyWrapper7",
    "textareaWrapp3",
    "floatyWrapper8"
  ],

  text: ["text"],
  dummySupportFormWrapper: [
    "dummySupportFormWrapper",
    "floatyWrapper7",
    "textareaWrapp3",
    "floatyWrapper8"
  ],

  floatyWrapper7: ["floatyWrapper7"],
  textareaWrapp3: ["textareaWrapp3"],
  floatyWrapper8: ["floatyWrapper8"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSupportContainer__ArgProps,
          internalVariantPropNames: PlasmicWebSupportContainer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSupportContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebSupportContainer";
  } else {
    func.displayName = `PlasmicWebSupportContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicWebSupportContainer = Object.assign(
  // Top-level PlasmicWebSupportContainer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    dummySupportFormWrapper: makeNodeComponent("dummySupportFormWrapper"),
    floatyWrapper7: makeNodeComponent("floatyWrapper7"),
    textareaWrapp3: makeNodeComponent("textareaWrapp3"),
    floatyWrapper8: makeNodeComponent("floatyWrapper8"),
    // Metadata about props expected for PlasmicWebSupportContainer
    internalVariantProps: PlasmicWebSupportContainer__VariantProps,
    internalArgProps: PlasmicWebSupportContainer__ArgProps
  }
);

export default PlasmicWebSupportContainer;
/* prettier-ignore-end */
